import React, { useState, useEffect, useContext } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { FunnelIcon } from "@heroicons/react/20/solid";
import { useMutation, useQuery } from "@apollo/client";
// import { toast } from "react-toastify";
import toast from "react-hot-toast";

import Filter from "./components/PreAuthFilter";
import PreAuthResponseModal from "./components/PreAuthResponseModal";
import gqlPreAuth from "../../gql/preAuth";
import DownloadExcel from "../../components/DownloadExcel";
import { appContext } from "../../context/ContextProvider";
import Pagination from "../../components/Pagination";
import PollBtn from "../../components/PollBtn";

import "./styles/pre-auth.css";
import "../Beneficiary/styles/BeneficiaryList.css";
import ConformationModal from "../../components/ConformationModal";
import AppModal from "../../components/AppModal";
import PreAuthJsonViewModal from "./PreAuthJsonViewModal";
import { BiSolidFileJson } from "react-icons/bi";
import { Badge, Tooltip } from "@mui/material";
import { TbEditCircle } from "react-icons/tb";
import { MdArrowCircleUp, MdOutlineRemoveRedEye, MdSync } from "react-icons/md";
import { BsFiletypeJson } from "react-icons/bs";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import ConvertPreAuthToClaimModal from "./ConvertPreAuthToClaimModal";
import { CgArrowsExchangeAlt } from "react-icons/cg";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { RiMessage2Line } from "react-icons/ri";
import claims from "../../gql/claims";
import { FaArrowUpFromBracket, FaRegCircleCheck } from "react-icons/fa6";
import ReplayIcon from "@mui/icons-material/Replay";
import PreAuthPbmModal from "./PreAuthPbmModal";
import { useTranslation } from "react-i18next";
import TableLoader from "../../common/TableLoader";
import TableSkeletonLoader from "../../common/TableLoading";
import RequestEligibilityModal from "../Eligibility/components/requestEligibility/RequestEligibilityModal";
import AppButton from "../../shared/AppButton";
import { FaFilter } from "react-icons/fa";
import AppTable from "../../shared/AppTable";
import StatusOutcomePill from "../../shared/StatusOutcomePill";
import { isEditLockedStatus } from "../../utils/transactionStatus";
import ReferralFlag from "../../components/ReferralFlag";

function PreAuthList(props) {
  const { t, i18n } = useTranslation();
  const { setShowLoader } = useContext(appContext);
  const navigate = useNavigate();
  const currentDate = new Date();
  const [loading, setLoading] = useState(false);
  const [openPbm, setOpenPbm] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [showFilters, setShowFilters] = useState(() => {
    const saved = sessionStorage.getItem("preAuthShowFilters");
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    sessionStorage.setItem("preAuthShowFilters", JSON.stringify(showFilters));
  }, [showFilters]);
  const [item, setItem] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPreAuthResponseModal, setShowPreAuthResponseModal] =
    useState(false);
  const [showConvertToClaimModal, setShowConvertToClaimModal] = useState(false);
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSeelectedItem] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fromDate = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1,
  ).padStart(2, "0")}-01`;
  const toDate = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1,
  ).padStart(2, "0")}-${new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0,
  ).getDate()}`;

  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);

  const [activeTab, setActiveTab] = useState(() => {
    const saved = sessionStorage.getItem("preAuthActiveTab");
    return saved !== null ? JSON.parse(saved) : "";
  });

  useEffect(() => {
    sessionStorage.setItem("preAuthActiveTab", JSON.stringify(activeTab));
  }, [activeTab]);

  const [preAuthFilters, setPreauthFilters] = useState(() => {
    const saved = sessionStorage.getItem("preAuthFiltersSaved");
    const savedTab = sessionStorage.getItem("preAuthActiveTab");
    const tabValue = savedTab !== null ? JSON.parse(savedTab) : "";

    if (saved) {
      try {
        const parsedFilters = JSON.parse(saved);
        return {
          ...parsedFilters,
          preauth_status: tabValue,
        };
      } catch (e) {
        console.error("Failed to parse saved preAuth filters", e);
      }
    }
    return {
      from_date: fromDate,
      to_date: toDate,
      fromDateOrdered: "",
      toDateOrdered: "",
      tpa_id: "",
      payer_id: "",
      type: "",
      patient_id: "",
      from_date_ordered: "",
      to_date_ordered: "",
      status: "",
      pre_auth_ref_no: "",
      pre_auth_bundle_id: "",
      is_followup_req: false,
      preauth_status: tabValue,
      limit: 10,
      page: 1,
    };
  });

  useEffect(() => {
    sessionStorage.setItem(
      "preAuthFiltersSaved",
      JSON.stringify(preAuthFilters),
    );
  }, [preAuthFilters]);

  const {
    loading: dataLoading,
    error,
    data,
    refetch,
  } = useQuery(gqlPreAuth.GET_PREAUTH_TRANSACTIONS, {
    variables: {
      input: {
        ...removeEmptyKeys(preAuthFilters),
      },
    },
    fetchPolicy: "network-only", // Always fetch from network, not cache
  });

  const [lastValidCounts, setLastValidCounts] = useState(null);

  useEffect(() => {
    if (data?.listPreAuthTransactions) {
      const { status_counts, preauth_status } = data.listPreAuthTransactions;
      // Update our count cache if we have status counts and we are either on the "All" tab 
      // or if the response actually contains multiple status counts (indicating it's a summary)
      if (status_counts && (preAuthFilters.preauth_status === "" || status_counts.length > 1)) {
        setLastValidCounts({
          total: data.listPreAuthTransactions.total,
          status_counts: status_counts
        });
      }
    }
  }, [data, preAuthFilters.preauth_status]);

  useEffect(() => {
    refetch();
  }, []);


  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message);
    }
  }, [error]);

  const {
    loading: excelDataLoading,
    error: excelDataError,
    data: excelDataResponse,
    refetch: refetchExcelDataResponse,
  } = useQuery(gqlPreAuth.GET_PREAUTH_EXCEL_DATA, {
    variables: {
      input: {
        from_date: fromDate,
        to_date: toDate,
      },
    },
    skip: true,
  });

  useEffect(() => {
    if (excelDataResponse) {
      setExcelData(
        JSON.parse(excelDataResponse?.listPreAuthTransactionsExcel?.data),
      );
    }
  }, [excelDataResponse]);

  const formatDateTime = (time) => {
    if (!time) return "-";
    const dateTime = new Date(time);
    if (Number.isNaN(dateTime.getTime())) return "-";
    const dateOnly = dateTime.toLocaleDateString("en-GB");
    const timeOnly = dateTime.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${dateOnly} </br> ${timeOnly}`;
  };

  const formatDateOnly = (date) => {
    if (!date) return "-";
    const parsedDate = new Date(date);
    return Number.isNaN(parsedDate.getTime())
      ? "-"
      : parsedDate.toLocaleDateString("en-GB");
  };

  const onDataRowClicked = (event, item) => {
    navigate("/preauth/details", { state: { currentItem: item } });
  };

  const onDataRowClickedCommunication = (event, item) => {
    navigate("/preauth/details", {
      state: { currentItem: item, tabToActive: "communications" },
    });
  };

  const onPageChange = async (currentPage) => {
    const payload = removeEmptyKeys(preAuthFilters);

    let filterInput = {
      ...payload,
      page: currentPage,
    };

    try {
      setLoading(true);
      await refetch({
        input: filterInput,
      });
    } finally {
      setLoading(false);
    }
    setPreauthFilters((prev) => ({
      ...prev,
      page: currentPage,
    }));
    /* localStorage.setItem('preAuthFilterDate', JSON.stringify(filterInput)); */
  };

  //cancel request
  const [
    cancelReq,
    { data: cancelData, loading: cancelLoading, error: cancelError },
  ] = useMutation(gqlPreAuth.CANCEL_REQUEST, {
    update(proxy, result) {
      onSuccessfulCancelRequestResponse(result.data);
    },
    onError(error) {
      onCancelResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulCancelRequestResponse = (data) => {
    if (data.cancelRequest) {
      toast.success("Successfully Cancelled!");
    } else {
    }
  };

  const onCancelResponseError = (error) => {
    toast.error(`${error.message}`);
  };

  const cancelClicked = async () => {
    cancelReq({
      variables: {
        input: {
          transaction_id: selectedItem?.transaction_id,
          request_name: "preAuth",
        },
      },
    }).then(async (res) => {
      /*
      const preAuthFilterDate = JSON.parse(
        localStorage.getItem("preAuthFilterDate")
      );

      let filterInput = {
        ...preAuthFilterDate,
        page: pageNo,
        limit: limit,
      };

      // Remove empty keys from claimsFilterDate
      const filteredPreAuthFilterDate = removeEmptyKeys(filterInput);
      */

      const filteredPreAuthFilterDate = removeEmptyKeys({
        ...preAuthFilters,
        page: pageNo,
        limit: limit,
      });

      try {
        setLoading(true);
        await refetch({
          input: filteredPreAuthFilterDate,
        });
      } finally {
        setLoading(false);
      }
    });
    setShowConfirmModal(false);
    setSeelectedItem(null);
  };
  const {
    loading: pollLoading,
    error: pollError,
    data: pollData,
    refetch: refetchPoll,
  } = useQuery(gqlPreAuth.PRE_AUTH_BULK_POLL_REQ, {
    skip: true, // Skip initial fetching
  });

  const {
    loading: communicationPollLoading,
    error: communicationPollError,
    data: communicationPollData,
    refetch: refetchCommunicationPoll,
  } = useQuery(gqlPreAuth.PRE_AUTH_COMMUNICATION_POLL, {
    skip: true, // Skip initial fetching
  });

  function removeEmptyKeys(obj) {
    const newObj = {};
    for (const key in obj) {
      if (obj[key] !== "") {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  }

  const pollClicked = () => {
    toast.loading("Requesting!");
    refetchPoll().then(async (res) => {
      toast.success(res?.data?.pollRequest?.message || "Request Successfully!");

      refetchCommunicationPoll();

      /*
      const preAuthFilterDate = JSON.parse(
        localStorage.getItem("preAuthFilterDate")
      );

      let filterInput = {
        ...preAuthFilterDate,
        page: pageNo,
        limit: limit,
      };

      // Remove empty keys from claimsFilterDate
      const filteredPreAuthFilterDate = removeEmptyKeys(filterInput);
      */

      let filterInput = {
        ...preAuthFilters,
        page: pageNo,
        limit: limit,
      };

      const filteredPreAuthFilterDate = removeEmptyKeys(filterInput);

      try {
        setLoading(true);
        await refetch({
          input: filteredPreAuthFilterDate,
        });
      } finally {
        setLoading(false);
      }
    });
  };

  //check Status
  const [
    checkReq,
    { data: checkData, loading: checkLoading, error: checkError },
  ] = useMutation(claims.CHECK_STATUS, {
    update(proxy, result) {
      onSuccessfulCheckRequestResponse(result.data);
    },
    onError(error) {
      onCancelResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulCheckRequestResponse = (data) => {
    if (!data.checkStatusRequest.nphies_err) {
      toast.success(
        data?.checkStatusRequest?.message || "Successfully Requested!",
      );
    } else if (data.checkStatusRequest.nphies_err) {
      // setErrorData(data.checkStatusRequest.nphies_err);
      // setShowErrorAlert(true);
    } else {
      toast.error(`Unknown Error`);
    }
  };

  const checkClicked = (item) => {
    toast.loading("Requesting!");
    checkReq({
      variables: {
        input: {
          transaction_id: item.transaction_id,
          request_name: "preAuth",
        },
      },
    });
  };
  const handleTabClick = async (tabName) => {
    setActiveTab(tabName);
    let filterInput = { ...preAuthFilters, preauth_status: tabName, page: 1 };
    const filteredPreAuthFilters = removeEmptyKeys(filterInput);
    try {
      setLoading(true);
      await refetch({ input: filteredPreAuthFilters });
    } finally {
      setLoading(false);
    }
    setPreauthFilters((prev) => ({
      ...prev,
      preauth_status: tabName,
      page: 1,
    }));
  };

  const getStatusBreakdown = (category) => {
    const defaultBreakdowns = {
      "need attention":
        "Null: 0, Empty: 0, Rejected: 0, Partial: 0, Cancelled: 0",
      processing: "Pended: 0, Pending: 0",
      approved: "Approved: 0, Not Required: 0",
    };
    const dataSource = lastValidCounts || data?.listPreAuthTransactions;
    if (!dataSource) {
      return defaultBreakdowns[category] || "";
    }

    const currentStatusCounts = dataSource.status_counts || [];

    if (category === "need attention") {
      const parts = [];
      const nullCount =
        currentStatusCounts.find((s) => s.status === "null")?.count || 0;
      const emptyCount =
        currentStatusCounts.find((s) => s.status === "empty")?.count || 0;
      const rejectedCount =
        currentStatusCounts.find((s) => s.status === "rejected")?.count || 0;
      const partialCount =
        currentStatusCounts.find((s) => s.status === "partial Approved")
          ?.count || 0;
      const cancelledCount =
        currentStatusCounts.find((s) => s.status === "cancelled")?.count || 0;

      if (nullCount > 0) parts.push(`Null: ${nullCount}`);
      if (emptyCount > 0) parts.push(`Empty: ${emptyCount}`);
      if (rejectedCount > 0) parts.push(`Rejected: ${rejectedCount}`);
      if (partialCount > 0) parts.push(`Partial: ${partialCount}`);
      if (cancelledCount > 0) parts.push(`Cancelled: ${cancelledCount}`);

      return parts.length > 0 ? parts.join(", ") : defaultBreakdowns[category];
    }

    if (category === "processing") {
      const parts = [];
      const pendedCount =
        currentStatusCounts.find((s) => s.status === "pended")?.count || 0;
      const pendingCount =
        currentStatusCounts.find((s) => s.status === "pending")?.count || 0;

      parts.push(`Pended: ${pendedCount}`);
      parts.push(`Pending: ${pendingCount}`);

      return parts.join(", ");
    }

    if (category === "approved") {
      const parts = [];
      const approvedCount =
        currentStatusCounts.find((s) => s.status === "approved")?.count || 0;
      const notRequiredCount =
        currentStatusCounts.find((s) => s.status === "not-required")?.count ||
        0;

      if (approvedCount > 0) parts.push(`Approved: ${approvedCount}`);
      if (notRequiredCount > 0)
        parts.push(`Not Required: ${notRequiredCount}`);

      return parts.length > 0 ? parts.join(", ") : defaultBreakdowns[category];
    }

    return "";
  };

  const getCountByStatus = (status) => {
    const dataSource = lastValidCounts || data?.listPreAuthTransactions;
    if (!dataSource) return 0;

    if (status === "all") return dataSource.total || 0;

    const currentStatusCounts = dataSource.status_counts || [];

    if (status === "need attention") {
      const statusesToSum = [
        "null",
        "empty",
        "rejected",
        "partial Approved",
        "cancelled",
      ];
      return (
        currentStatusCounts
          ?.filter((s) => statusesToSum.includes(s.status))
          ?.reduce((acc, curr) => acc + curr.count, 0) || 0
      );
    }

    if (status === "processing") {
      const statusesToSum = ["pended", "pending"];
      return (
        currentStatusCounts
          ?.filter((s) => statusesToSum.includes(s.status))
          ?.reduce((acc, curr) => acc + curr.count, 0) || 0
      );
    }

    if (status === "approved") {
      const statusesToSum = ["approved", "not-required"];
      return (
        currentStatusCounts
          ?.filter((s) => statusesToSum.includes(s.status))
          ?.reduce((acc, curr) => acc + curr.count, 0) || 0
      );
    }

    const found = currentStatusCounts?.find((s) => s.status === status);
    return found ? found.count : 0;
  };

  const getNetByStatus = (status) => {
    const dataSource = lastValidCounts || data?.listPreAuthTransactions;
    const statusCounts = dataSource?.status_counts || [];
    if (status === "") {
      return statusCounts.reduce(
        (sum, item) => sum + Number(item.total_net || 0),
        0,
      );
    }
    const groups = {
      approved: ["approved", "not-required"],
      processing: ["pended", "pending"],
      "need attention": ["null", "empty", "rejected", "partial Approved", "cancelled"],
    };
    const statuses = groups[status] || [status];
    return statusCounts
      .filter((item) => statuses.includes(item.status))
      .reduce((sum, item) => sum + Number(item.total_net || 0), 0);
  };

  const formatKpiAmount = (value) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value || 0);

  const approvalSummaryItems = [
    { label: t("Total Net"), tab: "", accent: "bg-slate-400", text: "text-slate-700" },
    { label: t("Approved Net"), tab: "approved", accent: "bg-emerald-500", text: "text-emerald-700" },
    { label: t("Processing Net"), tab: "processing", accent: "bg-sky-500", text: "text-sky-700" },
    { label: t("Rejected Net"), tab: "rejected", accent: "bg-rose-500", text: "text-rose-700" },
    { label: t("Need Attention Net"), tab: "need attention", accent: "bg-amber-500", text: "text-amber-700" },
  ];

  const columns = [
    {
      header: t("Status / Outcome"),
      width: "1%",
      render: (row) => (
        <div className="flex items-center gap-1 w-max">
          <StatusOutcomePill value={row?.outcome} variant="icon" />
          <StatusOutcomePill value={row?.status} />
        </div>
      ),
    },

    {
      header: t("Date Ordered"),
      render: (row) => formatDateOnly(row.date_ordered),
    },
     {
      header: t("Patient"),
      render: (row) => (
        <div className="flex flex-col min-w-[200px] py-1">
          <span className="font-bold text-gray-900 text-[12.5px] capitalize leading-snug">
            {row?.patient_name || "---"}
          </span>
          <div className="text-[11px] text-gray-500 font-medium mt-0.5">
           {t('Doc ID')}: {row?.document_id || row?.patient_document_id || "---"}
          </div>
        </div>
      ),
    },
    {
      header: t("Payer"),
      render: (row) => (
        <span className="text-gray-700 w-[220px] block whitespace-pre-wrap">
          {row?.payer_name || "---"}
        </span>
      ),
    },
    { header: t("Type"), field: "type" },
    {
      header: t("Response Date"),
      render: (row) => (
        <span
          dangerouslySetInnerHTML={{
            __html: formatDateTime(row.response_date),
          }}
        />
      ),
    },

    {
      header: t("Follow Up"),
      align: "center",
      render: (row) =>
        row?.is_followup_req ? (
          <Tooltip title={`${row?.followup_ref_transaction_id}`}>
            <div
              className="cursor-pointer text-blue-600 text-xl flex justify-center hover:scale-110 transition-transform"
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  "/preauth/details/" + row?.followup_ref_transaction_id,
                );
              }}
            >
              <MdArrowCircleUp />
            </div>
          </Tooltip>
        ) : (
          <span className="text-gray-400 text-xs">No</span>
        ),
    },
    {
      header: t("Referral"),
      align: "center",
      render: (row) => <ReferralFlag item={row} />,
    },
  ];

  return (
    <>
      <div class="pre_auth_container !p-0 ">
        <div className="flex justify-between items-start flex-col md:flex-row gap-1.5 mb-2">
          <div className="w-full sm:w-[calc(100%-150px)]">
            <span className="font-semibold text-black/70 text-lg ">
              {t("Pre-Auth Transactions")}
              <span className=" text-lg ml-1">
                ({data?.listPreAuthTransactions?.total || 0}{" "}
                <span className="text-xs font-bold italic">{t("Entries")}</span>
                )
              </span>
            </span>
          </div>
          <div className="w-full flex gap-1.5 flex-col md:flex-row justify-end ">
            {/*
            <AppButton
              label={t("AI Approval Agent")}
              onClick={() => navigate("/preauth/ai-agent")}
              startIcon={<AutoModeIcon />}
              variant="outlined"
              className="!border-primary !text-primary hover:!bg-primary/10"
            />
            */}
            <AppButton
              label={t("OCR")}
              onClick={() => {
                navigate("/ocr");
              }}
            />
            {/* <AppButton label={t("PBM")} onClick={() => setOpenPbm(true)} /> */}
            <AppButton
              label={t("Poll")}
              onClick={() => pollClicked()}
              startIcon={<ImportExportIcon />}
            />
            <AppButton
              label={t("Request Preauthorization")}
              onClick={() => navigate("/preauth/form")}
              startIcon={<AddIcon />}
            />
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
          <Filter
            refetch={refetch}
            refetchExcelDataResponse={refetchExcelDataResponse}
            setLoading={setLoading}
            preAuthFilters={preAuthFilters}
            setPreauthFilters={setPreauthFilters}
            setActiveTab={setActiveTab}
            fromDate={fromDate}
            toDate={toDate}
          />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-2 mb-2">
          {approvalSummaryItems.map((item) => (
            <div
              key={item.tab || "all"}
              className="rounded-md bg-white p-2 text-left shadow-sm border border-slate-100"
            >
              <div className="text-[10px] font-black uppercase truncate text-slate-500">
                {item.label}
              </div>
              <div className={`text-[13px] font-black mt-1 ${item.text}`}>
                {formatKpiAmount(getNetByStatus(item.tab))}
              </div>
            </div>
          ))}
        </div>
        {activeTab !== "" && getStatusBreakdown(activeTab) && (
          <div className="flex flex-wrap items-center gap-2 mb-1 px-1 animate-slideDown">
            <span className="text-[9px] md:text-[11px] font-black text-slate-400 uppercase tracking-wider mr-1">
              {t("Details")}:
            </span>
            {getStatusBreakdown(activeTab)
              .split(", ")
              .map((part, idx) => {
                const [label, count] = part.split(": ");
                const colors = {
                  Rejected: "bg-rose-50 text-rose-600 border-rose-100",
                  Null: "bg-slate-50 text-slate-600 border-slate-100",
                  Empty: "bg-gray-50 text-gray-600 border-gray-100",
                  Partial: "bg-orange-50 text-orange-600 border-orange-100",
                  Cancelled: "bg-red-50 text-red-600 border-red-100",
                  Pended: "bg-amber-50 text-amber-600 border-amber-100",
                  Pending: "bg-yellow-50 text-yellow-600 border-yellow-100",
                  Approved: "bg-emerald-50 text-emerald-600 border-emerald-100",
                  "Not Required": "bg-blue-50 text-blue-600 border-blue-100",
                };
                const colorClass = colors[label] || "bg-slate-50 text-slate-600 border-slate-100";

                return (
                  <div
                    key={idx}
                    className={`flex items-center px-2 md:px-3 py-0.5 rounded-md border text-[10px] md:text-xs font-bold shadow-sm transition-all hover:brightness-95 ${colorClass}`}
                  >
                    {label} :<span className="ml-1.5 font-black text-xs md:text-sm">{count}</span>
                  </div>
                );
              })}
          </div>
        )}

        <div className="my-2">
          <ul className="grid grid-flow-col text-center text-gray-500 bg-gray-100 rounded-lg p-1 shadow-inner overflow-x-auto">
            <li>
              <a
                className={`flex justify-center py-1 px-2 cursor-pointer hover:text-primary text-[13px] ${activeTab === "" ? "bg-[#0070C2] rounded-lg !text-white" : ""
                  }`}
                onClick={() => handleTabClick("")}
              >
                {t("All")}
              </a>
            </li>
            <li>
              <a
                className={`flex justify-center py-1 px-2 cursor-pointer hover:text-primary text-[13px] ${activeTab === "approved"
                  ? "bg-[#0070C2] rounded-lg !text-white"
                  : ""
                  }`}
                onClick={() => handleTabClick("approved")}
              >
                {t("Approved")}
              </a>
            </li>
            <li>
              <a
                className={`flex justify-center py-1 px-2 cursor-pointer hover:text-primary text-[13px] ${activeTab === "processing"
                  ? "bg-[#0070C2] rounded-lg !text-white"
                  : ""
                  }`}
                onClick={() => handleTabClick("processing")}
              >
                {t("Processing")}
              </a>
            </li>
            <li>
              <a
                className={`flex justify-center py-1 px-2 cursor-pointer hover:text-primary text-[13px] ${activeTab === "need attention"
                  ? "bg-[#0070C2] rounded-lg !text-white"
                  : ""
                  }`}
                onClick={() => handleTabClick("need attention")}
              >
                {t("Need Attention")}
              </a>
            </li>
          </ul>
        </div>

        <AppTable
          cellClassName="!py-0"
          actioncellClassName="!py-0"
          columns={columns}
          data={data?.listPreAuthTransactions?.data}
          loading={loading || dataLoading}
          onView={(row) => onDataRowClicked(null, row)}
          bodyRowPadding="7px"
          containerClassName="custom-table-scrollbar"
          canEditRow={(row) => !isEditLockedStatus(row?.status)}
          onEdit={(row) => navigate("/preauth/edit/form/" + row.transaction_id)}
          onJsonView={(row) => {
            setSeelectedItem(row);
            handleClickOpen();
          }}
          onCheck={(row) => checkClicked(row)}
          onConvert={(row) => {
            setSeelectedItem(row);
            setShowConvertToClaimModal(true);
          }}
          onCancel={(row) => {
            setSeelectedItem(row);
            setShowConfirmModal(true);
          }}
          onCommunication={(row) => onDataRowClickedCommunication(null, row)}
          getRowSx={(row) =>
            Number(row?.communication_count) > 0
              ? { backgroundColor: "#f1dfff" }
              : {}
          }
          onFollowUp={(row) =>
            navigate(`/preauth/edit/form/${row.transaction_id}/follow-up`)
          }
          LoaderComponent={
            <TableSkeletonLoader columnCount={11} rowCount={6} />
          }
        />
        <div>
          <Pagination
            currentPage={preAuthFilters.page}
            totalPages={data?.listPreAuthTransactions?.pages}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      <PreAuthPbmModal setOpen={setOpenPbm} open={openPbm} />
      <ConformationModal
        open={showConfirmModal}
        setOpen={setShowConfirmModal}
        onDelete={() => cancelClicked(item)}
        text={"Cancel"}
      />
      <PreAuthJsonViewModal
        setOpen={setOpen}
        open={open}
        handleClose={handleClose}
        selectedItem={selectedItem}
      />
      <ConvertPreAuthToClaimModal
        showConvertToClaimModal={showConvertToClaimModal}
        setShowConvertToClaimModal={setShowConvertToClaimModal}
        selectedItem={selectedItem}
      />
    </>
  );
}

export default PreAuthList;
